import { Box, Button, Stack, TextField, Typography } from '@mui/material';

export default function DownloadsEditor({ saving, downloads, onChange, onAdd, onRemove }) {
  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Addon items (add, edit or remove)
      </Typography>

      {downloads?.length ? (
        <Stack spacing={1}>
          {downloads.map((d, idx) => (
            <Box
              key={idx}
              sx={{ border: '1px solid #eee', borderRadius: 1, p: 1 }}
            >
              <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
                {d.length ? `(${d.length} KB)` : ''}
              </Typography>

              <Stack spacing={1}>
                <TextField
                  size="small"
                  label="Title"
                  value={d.title || ''}
                  onChange={(e) => onChange(idx, { title: e.target.value })}
                  fullWidth
                  disabled={saving}
                />
                <Button color="error" size="small" onClick={() => onRemove(idx)} disabled={saving}>
                  Remove item
                </Button>
                <TextField
                  size="small"
                  label="URL"
                  value={d.url || ''}
                  onChange={(e) => onChange(idx, { url: e.target.value })}
                  fullWidth
                  disabled={saving}
                />
              </Stack>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No downloads
        </Typography>
      )}
      <Button sx={{ mt: 1 }} size="small" variant="outlined" onClick={onAdd} disabled={saving}>
        Add item by URL
      </Button>
    </Box>
  );
}
